$shm_projects_page $mol_book2
	project_id \
	pages <= project_pages /
	Menu_page $mol_page
		title_content <= menu_title_rows /
		body /
			<= Menu $mol_view
				sub <= menu_rows /
	Menu_title $mol_string_button
		value? <=> project_title_draft? \
		submit? <=> project_title_commit? null
		event *
			^
			blur? <=> project_title_commit? null
			keydown? <=> project_title_keydown? null
	Project_actions $shm_service_task_menu
		remove_title \Удалить проект
		remove_confirm_title \Удалить проект?
		remove? <=> project_delete? null
	Version_label $mol_text
		text <= version_label \
	Section_link* $mol_link
		arg <= section_arg* *
		title <= section_title* \
		sub / <= section_title* \
	Product_page $mol_page
		title \Продукт
		body /
			<= Product_form $mol_form
				form_fields /
					<= Product_description_field $mol_form_field
						name \Описание
						Content <= Product_description $mol_textarea
							value? <=> product_description? \
					<= Product_problem_field $mol_form_field
						name \Проблема
						Content <= Product_problem $mol_textarea
							value? <=> product_problem? \
					<= Product_audience_field $mol_form_field
						name \Целевая аудитория
						Content <= Product_audience $mol_textarea
							value? <=> product_audience? \
					<= Product_value_field $mol_form_field
						name \Ценность
						Content <= Product_value $mol_textarea
							value? <=> product_value? \
					<= Product_scenarios_field $mol_form_field
						name \Ключевые сценарии
						Content <= Product_scenarios $mol_textarea
							value? <=> product_scenarios? \
					<= Product_success_field $mol_form_field
						name \Критерии успеха
						Content <= Product_success $mol_textarea
							value? <=> product_success? \
					<= Product_stage_field $mol_form_field
						name \Стадия
						Content <= Product_stage $mol_select
							value? <=> product_stage? \idea
							dictionary *
								idea \Идея
								prototype \Прототип
								mvp \MVP
								growing \Развивается
								support \Поддерживается
								archived \Архив
				submit_title \Сохранить
				message_done \Сохранено
				save? <=> product_save? null
	Draft_page $mol_page
		title \Черновик
		body /
			<= Draft $mol_textarea
				hint \Черновые заметки проекта
				value? <=> draft_note? \
	Tasks $shm_projects_tasks
		project_id <= project_id
	Development_page $mol_page
		title_content /
			<= Development_modes $mol_view
				sub <= development_mode_rows /
		body /
			<= Development $shm_projects_goal
				project_id <= project_id
				version <= version_next \
				output_mode? <=> development_output_mode? \process
				result_visible => development_result_visible
				Process => Development_process
				Result => Development_result
				Thinking => Development_thinking
				after /
					<= Development_stage $mol_view
						sub <= development_stage_rows /
	Development_output $shm_projects_goal_output
		mode? <=> development_output_mode? \process
		process <= Development_process
		result <= Development_result
	Docs $shm_projects_docs
		menu_title \Документация
		readme_text <= docs_readme_text \
		agents_text <= docs_agents_text \
		config_text <= docs_config_text \
	Tests_page $mol_page
		title \Тесты
		body /
			<= Project_tests $shm_projects_tests
				project_id <= project_id
	Preview_page $mol_page
		title_content /
			<= Preview_modes $mol_view
				sub <= preview_mode_rows /
		tools /
			<= Preview_open $mol_link
				hint \Открыть превью
				uri <= preview_open_uri \
				external true
				sub /
					<= Preview_open_icon $mol_icon_open_in_new
		body /
			<= Preview $mol_frame
				uri <= preview_url \about:blank
				style *
					^
					pointerEvents <= preview_pointer_events \auto
	Development_development $mol_link
		current <= development_mode_current false
		arg *
			project_tab \development
			project_preview null
		title \Разработка
		sub / \Разработка
	Development_preview $mol_link
		current <= preview_mode false
		arg *
			project_tab \development
			project_preview \true
		title \Превью
		sub / \Превью
	Preview_development $mol_link
		current <= development_mode_current
		arg *
			project_tab \development
			project_preview null
		title \Разработка
		sub / \Разработка
	Preview_preview $mol_link
		current <= preview_mode
		arg *
			project_tab \development
			project_preview \true
		title \Превью
		sub / \Превью
	Development_actions $mol_pick
		hint \Действия
		trigger_content /
			<= Development_actions_icon $mol_icon_dots_vertical
		bubble_content /
			<= Development_actions_list $mol_list
				rows <= rollback_rows /
	Rollback* $mol_button_minor
		title <= rollback_title* \
		click? <=> rollback*? null
	Prerelease_page $mol_page
		title \Пререлиз
		body /
			<= Prerelease_form $mol_view
				sub /
					<= Prerelease_transition $mol_text
						text <= prerelease_transition \
					<= Prerelease_deployment $mol_text
						text <= prerelease_status \
					<= Prerelease_changes_field $mol_form_field
						name \Список изменений
						Content <= Prerelease_changes $mol_textarea
							value? <=> version_changes? \
					<= Prerelease_make $mol_button_major
						title \Сделать пререлиз
						click? <=> prerelease_make? null
	Prerelease_summary $mol_view
		sub /
			<= Prerelease_transition
			<= Prerelease_deployment
			<= Prerelease_open $mol_link
				uri <= prerelease_uri \
				external true
				title \Открыть пререлиз
				sub / \Открыть пререлиз
	History_page $mol_page
		title \История версий
		body /
			<= Versions $mol_view
				sub <= version_rows /
	Version_link* $mol_link
		arg <= version_arg* *
		title <= version_title* \
		sub / <= version_title* \
	Version_page $mol_page
		title_content /
			<= Version_modes $mol_view
				sub <= version_mode_rows /
		body <= version_content /
	Version_result_mode $mol_link
		arg <= version_result_arg *
		current <= version_result_current false
		title \Результат
		sub / \Результат
	Version_session_mode $mol_link
		arg <= version_session_arg *
		current <= version_session_current false
		title \Сессия
		sub / \Сессия
	Version_details $mol_view
		sub /
			<= Version_date $mol_text
				text <= version_selected_date \
			<= Version_actions $mol_view
				sub <= version_action_rows /
			<= Requirements_section $mol_view
				sub /
					<= Requirements_title $mol_view
						sub / \Требования
					<= Version_requirements $mol_text
						text <= version_selected_requirements \
			<= Changes_section $mol_view
				sub /
					<= Changes_title $mol_view
						sub / \Что изменилось
					<= Changes $mol_list
						rows <= change_rows /
			<= Tests_section $mol_view
				sub /
					<= Tests_title $mol_view
						sub / <= version_tests_title \
					<= Version_tests $mol_list
						rows <= version_test_rows /
			<= Other_artifacts_section $mol_view
				sub /
					<= Other_artifacts_title $mol_view
						sub / \Другие артефакты
					<= Other_artifacts $mol_list
						rows <= other_artifact_rows /
	Version_session $mol_view
		sub <= version_session_rows /
	version_session_run null
	version_session_iteration* 0
	version_session_prerelease* false
	Version_session_chat* $shm_projects_goal_chat
		run <= version_session_run
		iteration <= version_session_iteration*
		prerelease <= version_session_prerelease* false
		version <= version_session_version \
	Version_release $mol_button_major
		title \Сделать релиз
		click? <=> release_make? null
	Version_prerelease $mol_button_major
		title \Сделать пререлизом
		click? <=> prerelease_activate? null
	Version_release_state $mol_text
		text <= version_release_status \
	Change* $mol_view
		sub <= change_content* /
	Change_title* $mol_view
		sub / <= change_title* \
	Change_description* $mol_text
		text <= change_description* \
	Change_screenshots* $mol_view
		sub <= change_screenshot_rows* /
	Change_screenshot* $mol_link
		uri <= change_screenshot_uri* \
		external true
		sub /
			<= Change_screenshot_image* $mol_image
				uri <= change_screenshot_uri* \
				loading \eager
				decoding \sync
	Version_test* $mol_link
		uri <= version_test_uri* \
		external true
		sub /
			<= Version_test_status* $mol_view
				sub / <= version_test_status* \
			<= Version_test_title* $mol_view
				sub / <= version_test_title* \
	Other_artifact* $mol_link
		uri <= other_artifact_uri* \
		external true
		title <= other_artifact_title* \
	No_other_artifacts $mol_view
		sub / \Других артефактов нет
